import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { Account, RewardsRedeem } from '../models';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpHelper } from '../../helpers/http.helper';

@Injectable()
export class AccountService extends CrudBaseService<Account> {
    constructor(protected override httpClient: HttpClient) {
        super('/account', httpClient);
    }

    convertAccount(accountID: string, status: boolean): Observable<any> {
        return this.httpClient.patch(`${this.basePath}/${accountID}/convert`, {
            data: { approved: status },
        });
    }

    convertLead(accountID: string): Observable<string> {
        return this.httpClient
            .get(`${this.basePath}/${accountID}/convert_lead`)
            .pipe(map((res: any) => res && res.data));
    }

    convertLeadThenGetAccount(accountID: string): Observable<Account> {
        return this.convertLead(accountID).pipe(
            switchMap((newID: string) => this.get(newID))
        );
    }

    rewardsRedeem(accountId: string): Observable<RewardsRedeem> {
        return this.httpClient
            .get(`${this.basePath}/${accountId}/rewards_redeem`)
            .pipe(map((res: any) => res && res.data));
    }

    filterUpgrade(filterParams: any): Observable<any[]> {
        return this.httpClient
            .get<any[]>(`${this.basePath}/upgrade`, {
                params: HttpHelper.objectToHttpParams({ ...filterParams }),
            })
            .pipe(map((res: any) => res && res.data));
    }

    approveUpgradeRequest(id: string): Observable<any> {
        const path = `${this.basePath}/upgrade/${id}/approve`;
        return this.httpClient.patch(path, {}).pipe(map((res) => res));
    }
    rejectUpgradeRequest(id: string): Observable<any> {
        const path = `${this.basePath}/upgrade/${id}/reject`;
        return this.httpClient.patch(path, {}).pipe(map((res) => res));
    }

}
